import { useAppDispatch, useAppSelector } from './state'
import {
  getNotifications as getNotificationsAPI,
  deleteNotification as deleteNotificationAPI,
  getNotification as getNotificationAPI
} from '../api/notifications'
import {
  setNotifications,
  setNotification,
  deleteNotification as deleteNotificationRedux,
  setNotificationsIsLoading,
  updateNotification,
  setNotificationsLastFetchedAt
} from '../state/slices/notifications_slice'
import { getResourceAuthorization } from '../state/selectors/resource_authorization'
import { useMemo } from 'react'

export const useNotification = () => {
  const dispatch = useAppDispatch()
  const currentResourceAuthorization = useAppSelector(getResourceAuthorization)
  const relationNumber = useMemo(() => currentResourceAuthorization?.relationNumber, [currentResourceAuthorization])

  const getNotifications = async () => {
    if (!currentResourceAuthorization || !relationNumber) return

    dispatch(setNotificationsIsLoading(true))
    try {
      const result = await getNotificationsAPI(relationNumber)

      if (result.data) {
        dispatch(setNotifications(result.data.inboxMessages))
        dispatch(setNotificationsLastFetchedAt(Date.now()))
      }

      return true
    } catch (e) {
      return false
    } finally {
      dispatch(setNotificationsIsLoading(false))
    }
  }

  const getNotification = async (id: string) => {
    if (!currentResourceAuthorization || !relationNumber) return

    dispatch(setNotificationsIsLoading(true))

    try {
      const result = await getNotificationAPI(relationNumber, id)

      if (result.data) {
        dispatch(setNotification(result.data.inboxMessage))
        dispatch(updateNotification(result.data.inboxMessage))
      }

      return true
    } catch (e) {
      return false
    } finally {
      dispatch(setNotificationsIsLoading(false))
    }
  }

  const deleteNotification = async (id: number) => {
    if (!currentResourceAuthorization || !relationNumber) return

    try {
      const result = await deleteNotificationAPI(relationNumber, id)

      if (result.data) {
        dispatch(deleteNotificationRedux(id))
      }

      return true
    } catch (e) {
      return false
    }
  }

  return {
    getNotifications,
    deleteNotification,
    getNotification
  }
}

export default useNotification
